import { Layout } from 'antd';
import { styled } from 'styled-components';

export const SideNavBarWarp = styled.aside`
  overflow: auto;
  background: linear-gradient(to top, var(--bg-leftmenu-panel-color), white);
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const Logo = styled.img`
  content: var(--img-afterlogin_logo);
  margin: 5px 10px 20px 0px;
  max-height: 70px;
  max-width: 220px;
  cursor: pointer;
  padding: 10px;

  &.setupLogo {
    padding: 0px;
    margin: 0px;
    max-width: 280px;
  }
`;

export const StyledSider = styled(Layout.Sider)`
  z-index: 999;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  .ant-layout-sider-children {
    background-color: var(--bg-leftmenu-panel-color);
  }

  @media screen and (max-width: 992px) {
    position: fixed !important;
  }
`;
export const TimeOutWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
